import { render, staticRenderFns } from "./LiefengTree.vue?vue&type=template&id=4a2ac68d&scoped=true&"
import script from "./LiefengTree.vue?vue&type=script&lang=js&"
export * from "./LiefengTree.vue?vue&type=script&lang=js&"
import style0 from "./LiefengTree.vue?vue&type=style&index=0&id=4a2ac68d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2ac68d",
  null
  
)

export default component.exports